import React, { useRef, useEffect, useCallback, useState} from 'react';
import {TAG} from './constants.js';
import {getSoundResultsServer} from './getSoundResults.js';
import {connect} from 'react-redux';
import ListResults from "components/selector2/ListResults.js";

const PackToSearch = ({
    showPianoRoll,
    bottomHeight,
    packToSearch,
    sequencerEngine,
    setPackToSearch,
    guildId
}) => { 
    let ref = useRef(undefined);
    let [results, setResults] = useState([]);
    useEffect(() => {
        getSoundResultsServer(
            50, "", guildId, TAG, 0, false, undefined, undefined, packToSearch)
            .then((r) => {
                if (r.length > 0) {
                    setResults(r);
                } else {
                    // THERES A BUG IN BACKEND WHERE IT SOMETIMES RETURNS 0
                    // NON_DETERMINISTICALLY (I NO, BAD!). BUT SEARCHING AGAINN
                    // USUALLY FIXES IT
                    setTimeout(() => {
                        getSoundResultsServer(
                            50,
                            "", guildId, TAG, 0, false, undefined, undefined, packToSearch)
                            .then(setResults);
                    }, 500);
                }
            });
    }, [packToSearch, setResults]);
    let style = {
        height: window.innerHeight - 263
    };

    if (showPianoRoll) {
        style.height -= bottomHeight - 150;
    }

    return (
        <div ref={ref} style={style} className="source-to-search-results">
          <ListResults
            setPackToSearch={setPackToSearch}
            scrollRef={ref}
            packToSearch={packToSearch}
            isPack={true}
            size={1000}
            searchTerm={""}
            results={results}
            sequencerEngine={sequencerEngine}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      showPianoRoll: state.sequencer.showPianoRoll,
      bottomHeight: state.arrangement.bottomHeight,
      guildId: state.guilds.selectedGuild ? state.guilds.selectedGuild.guildId : 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PackToSearch);
